var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button",style:(_vm.buttonStyle),attrs:{"type":"button","id":_vm.buttonID,"disabled":_vm.disabled},on:{"click":function($event){return _vm.emit('click')}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }